<div class="plan-selector">
    <select legacy-css class="form-control" [formControl]="planControl">
        <option [value]="plan.ID_Plan" *ngFor="let plan of plans">
            <span>{{ plan.PlanLabel }}</span>
        </option>
    </select>

    <h3 class="measurement-title" *ngIf="measurement">{{ measurement.description }}</h3>
</div>
